import { combineReducers } from "@reduxjs/toolkit";
import examReducer from "./examSlice";
import websocketReducer from './websocketSlice';

export const rootReducer = combineReducers({
    exam: examReducer,
    websocket: websocketReducer,
});